import { setComponentMapOverrides } from '@jutro/uiconfig';
import FNOLHOWizard from './FNOLHOWizard';
import FNOLHOTypeOfIncidentPage from './pages/TypeOfIncident/TypeOfIncidentPage';
import FNOLFireDamagePage from './pages/FireDamage/FireDamagePage';
import FNOLWaterDamagePage from './pages/WaterDamage/WaterDamagePage';
import FNOLCriminalDamagePage from './pages/CriminalDamage/CriminalDamagePage';
import FNOLWindDamagePage from './pages/WindDamage/WindDamagePage';
import FNOLOtherDamagePage from './pages/OtherDamage/OtherDamagePage';
import LossPropertyIncidentDetail from './pages/LossPropertyIncidentDetails/LossPropertyIncidentDetails';
import FNOLHOWhatPage from './pages/What/WhatPage';

setComponentMapOverrides(
    {
        FNOLHOWizard: { component: 'FNOLHOWizard' },
        FNOLHOTypeOfIncidentPage: { component: 'FNOLHOTypeOfIncidentPage' },
        FNOLFireDamagePage: { component: 'FNOLFireDamagePage' },
        FNOLWaterDamagePage: { component: 'FNOLWaterDamagePage' },
        FNOLCriminalDamagePage: { component: 'FNOLCriminalDamagePage' },
        FNOLWindDamagePage: { component: 'FNOLWindDamagePage' },
        FNOLOtherDamagePage: { component: 'FNOLOtherDamagePage' },
        LossPropertyIncidentDetail: {component: 'LossPropertyIncidentDetail'},
        FNOLHOWhatPage: { component: 'FNOLHOWhatPage' },
    },
    {
        FNOLHOWizard,
        FNOLHOTypeOfIncidentPage,
        FNOLFireDamagePage,
        FNOLWaterDamagePage,
        FNOLCriminalDamagePage,
        FNOLWindDamagePage,
        FNOLOtherDamagePage,
        FNOLHOWhatPage,
        LossPropertyIncidentDetail
    }
);

export {
    FNOLHOWizard as default
};
